<div class="edit-patient-panel configure-container">
  <perfect-scrollbar style="max-width: 100%; top: 0; left: 0;">
    <app-edit-patient-content (cancelEditEvent)="closePanel()"></app-edit-patient-content>
  </perfect-scrollbar>
</div>
